export enum Routes {
  SettingRouter = "*",
  SettingDetailPageRouter = "/setting/tenant/detail/",
  FleetSettingDetailPageRouter = "/setting/tenant/fleet/detail/",
  ListingDefaultsDetailPageRouter = "/setting/tenant/listing-defaults/detail/",
  SettingApplicationDashboardPageRouter = "/setting/application/dashboard",
  SettingApplicationSettingsPageRouter = "/setting/application/settings",
  TranslationSearchPageRouter = "/setting/application/translation/search",
  TranslationCreatePageRouter = "/setting/application/translation/new",
  TranslationEditPageRouter = "/setting/application/translation/:translationId?",
  TranslationDetailPageRouter = "/setting/application/translation/detail/:translationId",
  TranslationDeletePageRouter = "/setting/application/translation/delete/:translationId",
  DocumentDetailPageRouter = "/setting/tenant/document/detail/",
  OfficesSearchPageRouter = "/setting/tenant/offices/search",
  TenantSearchPageRouter = "/setting/application/tenant/search",
  TenantDetailPageRouter = "/setting/application/tenant/detail/:tenantId",
  TenantOfficesSearchPageRouter = "/setting/application/tenant/detail/:tenantId/offices",
  TenantUsersSearchPageRouter = "/setting/application/tenant/detail/:tenantId/users",
  TenantVehiclesSearchPageRouter = "/setting/application/tenant/detail/:tenantId/vehicles",
  TenantSubscriptionPageRouter = "/setting/application/tenant/detail/:tenantId/subscription",
  TenantInvoicesPageRouter = "/setting/application/tenant/detail/:tenantId/invoices",
  TenantActivitiesPageRouter = "/setting/application/tenant/detail/:tenantId/activities",
}
